import axios from 'axios';

const BASE_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

if (!BASE_URL && process.env.NODE_ENV === 'production') {
  // Falla ruidosamente en el build en vez de mandar peticiones a "undefined/api/..."
  throw new Error(
    'REACT_APP_BACKEND_URL no está definida. Configurala en las variables de entorno del proyecto.'
  );
}

export const TOKEN_KEY = '7en1.token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) =>
  token ? localStorage.setItem(TOKEN_KEY, token) : localStorage.removeItem(TOKEN_KEY);

const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/** Se registra desde AuthContext para cerrar sesión cuando el token deja de valer. */
let onUnauthorized = () => {};
export const setUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      setToken(null);
      onUnauthorized();
    }
    return Promise.reject(error);
  }
);

/** Extrae el mensaje que el backend manda en `detail`, con un texto de respaldo. */
export const errorMessage = (error, fallback = 'Ocurrió un error') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  if (error?.code === 'ECONNABORTED') return 'El servidor tardó demasiado en responder';
  if (!error?.response) return 'No se pudo conectar con el servidor';
  return fallback;
};

export default api;
